var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49935 17.3334C3.89685 17.3334 0.166016 13.6026 0.166016 9.00008C0.166016 4.39758 3.89685 0.666748 8.49935 0.666748C13.1018 0.666748 16.8327 4.39758 16.8327 9.00008C16.8327 13.6026 13.1018 17.3334 8.49935 17.3334ZM6.59102 15.3892C5.76886 13.6453 5.29258 11.7586 5.18852 9.83342H1.88435C2.0465 11.1158 2.57762 12.3236 3.41316 13.3098C4.24869 14.2961 5.35269 15.0185 6.59102 15.3892ZM6.85768 9.83342C6.98352 11.8659 7.56435 13.7751 8.49935 15.4601C9.45962 13.7305 10.0206 11.808 10.141 9.83342H6.85768ZM15.1143 9.83342H11.8102C11.7061 11.7586 11.2298 13.6453 10.4077 15.3892C11.646 15.0185 12.75 14.2961 13.5855 13.3098C14.4211 12.3236 14.9522 11.1158 15.1143 9.83342ZM1.88435 8.16675H5.18852C5.29258 6.24157 5.76886 4.35482 6.59102 2.61091C5.35269 2.98165 4.24869 3.70404 3.41316 4.69033C2.57762 5.67661 2.0465 6.88433 1.88435 8.16675ZM6.85852 8.16675H10.1402C10.02 6.19225 9.45932 4.26969 8.49935 2.54008C7.53908 4.26962 6.97815 6.19218 6.85768 8.16675H6.85852ZM10.4077 2.61091C11.2298 4.35482 11.7061 6.24157 11.8102 8.16675H15.1143C14.9522 6.88433 14.4211 5.67661 13.5855 4.69033C12.75 3.70404 11.646 2.98165 10.4077 2.61091Z",
    fill: "#111811"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.211b3c08d85983803b7670c28ec1db74.svg";
export { ForwardRef as ReactComponent };